import React, { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "../services/supabase";

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const [profileRole, setProfileRole] = useState(null);     // 'admin' | 'collaborateur' | 'client'
  const [currentMode, setCurrentMode] = useState(null);     // 'admin' | 'collaborateur'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadRoleFromSession = async (session) => {
      try {
        if (!session?.user) {
          setProfileRole(null);
          setCurrentMode(null);
          setLoading(false);
          return;
        }

        const { data, error } = await supabase
          .from("profiles")
          .select("role")
          .eq("id", session.user.id)
          .single();

        if (error) throw error;

        const role = data?.role || "client";
        setProfileRole(role);

        if (role === "admin") {
          setCurrentMode("admin");
        } else if (role === "collaborateur") {
          setCurrentMode("collaborateur");
        } else {
          setCurrentMode(null);
        }
      } catch (e) {
        console.error("Erreur chargement rôle :", e);
      } finally {
        setLoading(false);
      }
    };

    // 1️⃣ Session initiale
    supabase.auth.getSession().then(({ data }) => {
      loadRoleFromSession(data.session);
    });

    // 2️⃣ Écoute login / logout
    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setLoading(true);
        loadRoleFromSession(session);
      }
    );

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  const canSwitchMode = profileRole === "admin";

  const switchMode = () => {
    if (!canSwitchMode) return;
    setCurrentMode((prev) =>
      prev === "admin" ? "collaborateur" : "admin"
    );
  };

  return (
    <RoleContext.Provider
      value={{
        profileRole,
        currentMode,
        canSwitchMode,
        switchMode,
        loading,
      }}
    >
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);

